import React, { useMemo } from 'react';
import styles from './ResourceCardStats.module.scss';
import { useUIGameEndContext } from '../../../../../contexts/UIGameEndContext.tsx';
import { BarChart } from '../../BarChart/index.ts';
import { CardDataController } from '@colonist/game-card-types';
import { UIGameCard } from '../../../../../common/UIGameCard/index.ts';
import { T } from '@colonist/ui';
import { useGameStore } from '../../../../../store/GameStoreContext.ts';
export const ResourceCardStats = ()=>{
    const { gameEndData } = useUIGameEndContext();
    const activeResourceCardTypes = useGameStore((state)=>state.gameMode.activeResourceCardTypes);
    const activeResourceCards = CardDataController.getCardEnumsOfTypes(activeResourceCardTypes);
    const resourceCardsCountMap = useMemo(()=>{
        const countMap = {};
        gameEndData.endGameState.resourceCardsStats.forEach((num)=>{
            if (countMap[num] === undefined) {
                countMap[num] = 0;
            }
            countMap[num] += 1;
        });
        return countMap;
    }, [
        gameEndData
    ]);
    const chartData = useMemo(()=>activeResourceCards.map((cardId)=>{
            var _resourceCardsCountMap_cardId;
            return {
                label: /*#__PURE__*/ React.createElement(UIGameCard, {
                    cardEnum: cardId,
                    className: styles.card,
                    showTipTitle: true
                }),
                value: (_resourceCardsCountMap_cardId = resourceCardsCountMap[cardId]) !== null && _resourceCardsCountMap_cardId !== void 0 ? _resourceCardsCountMap_cardId : 0
            };
        }), [
        activeResourceCards,
        resourceCardsCountMap
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.resourceCards.cardsDrawn'
        }
    })), /*#__PURE__*/ React.createElement(BarChart, {
        chartData: chartData
    }));
};
